// src/components/RPA/buttons/UploadInventoryObservationButton.js
// ✅ FIXED - Physical Inventory Observation Upload (Step 13) - Correct API Route
import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API || 'http://localhost:8000';

const UploadInventoryObservationButton = ({ docId, disabledHint, onDone }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const downloadTemplate = () => {
    const csv = `Observation Date,Location,Item Number,Item Description,Auditor Count,Client Count,Unit,Condition,Difference,Notes,Observer Name
12/31/2024,Main Warehouse,INV-001,Raw Material A,1000,1000,units,good,0,Counted in Bin A1,John Smith
12/31/2024,Main Warehouse,INV-002,Finished Goods B,500,495,units,good,5,Minor discrepancy noted,John Smith
12/31/2024,Storage Room,INV-003,Work in Progress C,250,250,units,damaged,0,Some water damage observed,Jane Doe`;
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Inventory_Observation_Template.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file');
      return;
    }

    if (!docId) {
      setError('No document ID provided');
      return;
    }

    setUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('inventoryObservation', file);

    try {
      // ✅ FIXED: Use correct route pattern /admin/rpa/docs/${docId}/inventory-observation/upload
      const res = await axios.post(
        `${API_URL}/admin/rpa/docs/${docId}/inventory-observation/upload`,
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true
        }
      );
      console.log('[INV_OBS] Success:', res.data);
      setResult(res.data);
      if (onDone) setTimeout(onDone, 2000);
    } catch (err) {
      console.error('[INV_OBS] Error:', err);
      setError(err.response?.data?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ padding: '20px', background: '#f8f9fa', borderRadius: '8px' }}>
      <h4 style={{ marginTop: 0, color: '#2c3e50' }}>👁️ Physical Inventory Observation (Step 13)</h4>
      <p style={{ fontSize: '14px', color: '#6c757d' }}>
        Upload physical inventory observation results. Documents test counts and observation procedures.
      </p>

      {disabledHint && (
        <div style={{ padding: '10px', background: '#fff3cd', borderRadius: '6px', marginBottom: '12px', fontSize: '14px' }}>
          ⚠️ {disabledHint}
        </div>
      )}

      <button 
        onClick={downloadTemplate} 
        style={{ 
          padding: '8px 16px', 
          background: '#6c757d', 
          color: 'white', 
          border: 'none', 
          borderRadius: '6px', 
          marginBottom: '12px', 
          cursor: 'pointer',
          fontSize: '14px'
        }}
      >
        📄 Download Template
      </button>

      <input 
        type="file" 
        accept=".csv,.txt" 
        onChange={(e) => { setFile(e.target.files[0]); setError(null); setResult(null); }} 
        disabled={!!disabledHint || uploading} 
        style={{ display: 'block', marginBottom: '12px' }} 
      />

      {file && (
        <div style={{ padding: '8px', background: '#e7f3ff', borderRadius: '4px', marginBottom: '12px', fontSize: '13px' }}>
          📎 {file.name}
        </div>
      )}

      <button 
        onClick={handleUpload} 
        disabled={!file || uploading || !!disabledHint} 
        style={{ 
          padding: '12px 24px', 
          background: !file || uploading || disabledHint ? '#ccc' : '#9c27b0', 
          color: 'white', 
          border: 'none', 
          borderRadius: '6px', 
          cursor: !file || uploading || disabledHint ? 'not-allowed' : 'pointer', 
          fontWeight: '600',
          fontSize: '15px',
          width: '100%'
        }}
      >
        {uploading ? '⏳ Uploading Observation Data...' : '✅ Upload Inventory Observation'}
      </button>

      {error && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#f8d7da', color: '#721c24', borderRadius: '6px', fontSize: '14px' }}>
          ❌ {error}
        </div>
      )}
      
      {result && (
        <div style={{ marginTop: '12px', padding: '12px', background: '#d4edda', color: '#155724', borderRadius: '6px' }}>
          <strong>✅ Inventory Observation Uploaded Successfully!</strong>
          <div style={{ marginTop: '8px', fontSize: '13px' }}>
            • Test Counts: {result.summary?.totalCounts || 0}<br/>
            • Matched: {result.summary?.matchedCount || 0}<br/>
            • Exceptions: {result.summary?.exceptionCount || 0}<br/>
            • Damaged Items: {result.summary?.damagedCount || 0}
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadInventoryObservationButton;